/* eslint-disable no-redeclare */

import {
  DomainSessionId,
  DomainUserId,
  SessionId,
} from '@hc-frontend/core-types';
import { z } from 'zod';

export const EventName = z.enum(['hc_contact']);
export type EventName = z.infer<typeof EventName>;

export const MarketingProduct = z.enum(['Healthcare', 'Medicare']);
export type MarketingProduct = z.infer<typeof MarketingProduct>;

export const SendEventRequest = z.object({
  event_name: EventName,
  payload: z.object({
    domain_user_id: DomainUserId,
    domainSessionId: DomainSessionId,
    sessionId: SessionId,
    product: MarketingProduct,
    on: z.string().datetime(),
  }),
});
export type SendEventRequest = z.infer<typeof SendEventRequest>;

export const SendEventResponse = z.undefined();
export type SendEventResponse = z.infer<typeof SendEventResponse>;
